import { useMediaQuery } from "@mui/material";
import { useReducedMotion } from "framer-motion";

/**
 * Central place that decides how aggressive animations should be.
 * On mobile or when the user prefers reduced motion we disable heavy
 * parallax and keep only lightweight opacity / translateY transitions.
 */
export function useMotionConfig() {
  const prefersReduced = useReducedMotion();
  const isMobile = useMediaQuery("(max-width:900px)");

  const lightMode = Boolean(prefersReduced || isMobile);

  return {
    isMobile,
    prefersReduced: Boolean(prefersReduced),
    // When true, components should skip parallax / 3D and use simple fades.
    lightMode,
    // Disable absolutely everything (respect explicit reduced-motion).
    disabled: Boolean(prefersReduced),
  };
}
